<template>
  <card>
    <div slot="header">
      <b-row align-v="center">
        <b-col cols="8">
          <h3 class="mb-0">Status Page Settings</h3>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col cols="8">
          <small>
            Customize your status page and share it with your users.
          </small>
        </b-col>
      </b-row>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(save)">
        <h6 class="heading-small text-muted mb-1">
          Public Status Page Settings
        </h6>
        <b-row>
          <b-col v-if="hasPremium" lg="4" style="align-self: center;">
            <b-form-checkbox class="mb-3" v-model="form.isPublic">
              Public status page
            </b-form-checkbox>
          </b-col>
          <b-col lg="8">
            <base-input
              label="Status page URL"
              v-model="form.url"
              :disabled="!form.isPublic"
              rules="alpha_dash"
              name="URL"
            >
              <small slot="prepend">
                https://boltscale.io/status/
              </small>
            </base-input>
          </b-col>
        </b-row>
        <h6 class="heading-small text-muted mb-1">Customization</h6>
        <div>
          <b-row>
            <b-col lg="12">
              <!--
              <div>
                <label class="form-control-label">
                  Make your status page public?
                </label>
              </div>
              <base-switch class="mr-1" v-model="form.isPublic"></base-switch>
            --></b-col>
          </b-row>
          <b-row>
            <b-col lg="4">
              <base-input v-model="form.name" name="Name">
                <div slot="label">
                  <label class="form-control-label">
                    Status page name
                    <i
                      class="fa fa-question-circle"
                      aria-hidden="true"
                      v-b-tooltip.hover.top
                      title="The status page name is displayed prominently on your status page."
                    ></i>
                  </label>
                </div>
              </base-input>
            </b-col>
            <b-col lg="8">
              <base-input>
                <div slot="label">
                  <label class="form-control-label">
                    Public Description
                    <i
                      class="fa fa-question-circle"
                      aria-hidden="true"
                      v-b-tooltip.hover.top
                      title="The description is shown at the top of your status page."
                    ></i>
                  </label>
                </div>
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea3"
                  rows="2"
                  v-model="form.description"
                ></textarea>
              </base-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="3">
              <base-button
                type="primary"
                @click="handleSubmit(save)"
                :loading="buttons.save.loading"
              >
                Save
              </base-button>
            </b-col>
          </b-row>
        </div>
      </b-form>
    </validation-observer>
  </card>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      form: {
        isPublic: false,
        url: "",
        name: "",
        description: ""
      },
      buttons: {
        save: {
          loading: false
        }
      },
      components: [],
      notificationSubscriptions: []
    };
  },
  computed: {
    ...mapGetters("user", ["hasPremium"])
  },
  methods: {
    async save(component, i) {
      this.buttons.save.loading = true;

      const resp = await this.$http.post("/settings/statusPage", {
        isPublic: this.form.isPublic,
        url: this.form.url,
        description: this.form.description,
        name: this.form.name
      });

      if (resp.data.success) {
        this.$toasted.show("Saved settings.", {
          type: "success",
          duration: 5000
        });
      }

      this.buttons.save.loading = false;
    },
    addSlackNotification(component) {
      let currentUrl = `https://${window.location.hostname}/settings/notifications`;
      let redirectUrl = `https://${window.location.hostname}/handleSlackWebhook`;

      localStorage.slack = JSON.stringify({
        redirectUri: currentUrl,
        componentId: component.id
      });

      console.log(localStorage);

      const slackUrl =
        "https://slack.com/oauth/v2/authorize?client_id=786644536177.1208376345524&scope=incoming-webhook&user_scope=&redirect_uri=" +
        redirectUrl;

      console.log(slackUrl);
      window.location.href = slackUrl;
    }
  },
  async mounted() {
    const resp = await this.$http.get("/settings/statusPage");
    //this.form.isPublic = resp.data.isPublic;
    //this.form.url = resp.data.url;
    this.form = { ...resp.data };
    console.log("AHHHH");
    console.log(this.form);
  }
};
</script>
<style>
.favicon-img {
  width: 16px;
  margin-right: 16px;
}

.public-toggle {
  width: 72px;
}
.public-toggle input:checked + .custom-toggle-slider:before {
  -webkit-transform: translateX(45px);
  transform: translateX(45px);
}
</style>
